import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

// ─── Tokens ────────────────────────────────────────────────────────────────────
const SERIF = "'Newsreader', Georgia, serif";
const NAVY  = '#16304a';
const TEAL  = '#1d6f6a';
const GOLD  = '#c79a3a';
const BEIGE = '#f6efe2';
const SELF  = '/coverage/education';

// ─── Sponsored Band (untouched) ────────────────────────────────────────────────
function SponsoredBand() {
  return (
    <div style={{ background: BEIGE, marginTop: 40 }} data-testid="ed-sponsored-band">
      <div className="container-custom">
        <div style={{ padding: '26px 0' }}>
          <div style={{ fontWeight: 700, fontSize: 9.5, letterSpacing: '1.4px', textTransform: 'uppercase', color: '#a8967a', marginBottom: 12 }}>Sponsored Content</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 30, flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 0', minWidth: 240 }}>
              <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 25, lineHeight: 1.1, margin: '0 0 7px', color: NAVY }}>Better decisions. Stronger outcomes.</h2>
              <p style={{ fontSize: 13, color: '#6c6258', margin: '0 0 9px', maxWidth: 380 }}>Data and insights to help education leaders drive impact that lasts.</p>
              <Link to={SELF} style={{ color: NAVY, fontWeight: 600, fontSize: 12.5, textDecoration: 'none' }}>Learn More →</Link>
            </div>
            <svg viewBox="0 0 280 120" width="280" style={{ flexShrink: 0, maxWidth: '42%' }} aria-hidden="true">
              <rect x="40" y="64" width="22" height="50" fill="#16304a"/>
              <rect x="66" y="44" width="22" height="70" fill="#1d6f6a"/>
              <rect x="92" y="74" width="22" height="40" fill="#cdbf9f"/>
              <rect x="118" y="34" width="22" height="80" fill="#16304a"/>
              <rect x="144" y="58" width="22" height="56" fill="#c79a3a"/>
              <rect x="170" y="48" width="22" height="66" fill="#1d6f6a"/>
              <rect x="196" y="70" width="22" height="44" fill="#16304a"/>
            </svg>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
              <svg width="50" height="50" viewBox="0 0 70 70" aria-hidden="true">
                <g stroke={GOLD} strokeWidth="1.6" strokeLinecap="round">
                  <line x1="49" y1="35" x2="64" y2="35"/><line x1="47.1" y1="42" x2="60" y2="49"/>
                  <line x1="42" y1="47.1" x2="49" y2="60"/><line x1="35" y1="49" x2="35" y2="64"/>
                  <line x1="28" y1="47.1" x2="21" y2="60"/><line x1="22.9" y1="42" x2="10" y2="49"/>
                  <line x1="21" y1="35" x2="6" y2="35"/><line x1="22.9" y1="28" x2="10" y2="21"/>
                  <line x1="28" y1="22.9" x2="21" y2="10"/><line x1="35" y1="21" x2="35" y2="6"/>
                  <line x1="42" y1="22.9" x2="49" y2="10"/><line x1="47.1" y1="28" x2="60" y2="21"/>
                </g>
                <circle cx="35" cy="35" r="8" fill="none" stroke={GOLD} strokeWidth="1.6"/>
              </svg>
              <div>
                <div style={{ fontFamily: SERIF, fontSize: 24, lineHeight: 1, color: NAVY, fontWeight: 500 }}>LearnForward</div>
                <div style={{ fontSize: 9.5, letterSpacing: '1.5px', textTransform: 'uppercase', color: '#8a8170', marginTop: 4 }}>By Opportunity Post</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Sector Config ─────────────────────────────────────────────────────────────
const EDUCATION_CONFIG = {
  slug: 'education',
  label: 'Education',
  selfPath: SELF,
  heroSlug: 'coverage/education',
  h1Text: 'Education',
  h1Subtitle: 'Strong schools. Inspired learners. Prepared workforce. Expanding opportunity from early learning to lifelong success.',
  h1Body: 'Independent reporting and smart analysis on the policies, innovations, and leaders shaping education outcomes and economic mobility.',
  briefingCtaText: "Read Today's Education Briefing",
  storiesCtaText: 'Explore Education Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Education Briefings',
  testId: 'education-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:24', title: 'Closing the Opportunity Gap Starts Early', description: 'How districts and communities are closing learning gaps before they widen.' },
    { type: 'in_focus', label: 'Campus in Focus', name: 'Campus Spotlight', description: 'Expanding access, advancing research, and strengthening community impact.' },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

// ─── Page ──────────────────────────────────────────────────────────────────────
export default function EducationPage() {
  return (
    <SectorPage
      config={EDUCATION_CONFIG}
      PulseBar={() => <Ticker scope="education" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
